import { render, staticRenderFns } from "./ShareAndSettlement.vue?vue&type=template&id=1b8f9f1d"
import script from "./ShareAndSettlement.vue?vue&type=script&lang=js"
export * from "./ShareAndSettlement.vue?vue&type=script&lang=js"
import style0 from "./ShareAndSettlement.vue?vue&type=style&index=0&id=1b8f9f1d&prod&lang=scss"
import style1 from "./ShareAndSettlement.vue?vue&type=style&index=1&id=1b8f9f1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports